import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { getPopularFeaturesByProductLine } from 'pricing-pages-lib/utils/featureUtils';
import { useMemo } from 'react';
import { MARKETING_HUB_PROFESSIONAL, SALES_HUB_PROFESSIONAL } from 'self-service-api/constants/ApiNames';
import { useFeaturesByProductLines } from '../../../hooks/useFeatures';
import RecommendedPopularFeatureCard from './RecommendedPopularFeatureCard';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ApiNameToProductName = {
  [MARKETING_HUB_PROFESSIONAL]: 'pricingPage.products.MARKETING.PROFESSIONAL',
  [SALES_HUB_PROFESSIONAL]: 'pricingPage.products.SALES.PROFESSIONAL'
};
const RecommendedSalesFeaturesPanel = ({
  featureStoreFeature,
  productLevel,
  productLine,
  apiName
}) => {
  const {
    featuresByProductLine
  } = useFeaturesByProductLines({
    productLineToApiName: {
      [productLine]: [apiName]
    }
  });
  const popularFeatures = useMemo(() => {
    return getPopularFeaturesByProductLine({
      featuresByProductLine,
      productLine,
      upgradePointApiName: apiName,
      upgradePointFeature: featureStoreFeature,
      productLevel
    });
  }, [featuresByProductLine, productLine, apiName, featureStoreFeature, productLevel]);
  if (!popularFeatures.length) return null;
  return /*#__PURE__*/_jsxs(TFlex, {
    direction: "column",
    align: "center",
    children: [/*#__PURE__*/_jsx(Text, {
      as: "h3",
      marginBlockStart: "800",
      marginBlockEnd: "800",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "interstitial.recommendedSalesPopularFeatures",
        options: {
          apiName: I18n.text(ApiNameToProductName[apiName])
        }
      })
    }), /*#__PURE__*/_jsx(Grid, {
      flexDirection: "row",
      children: popularFeatures.map(featureUpgradeConfig => /*#__PURE__*/_jsx(GridItem, {
        size: 4,
        children: /*#__PURE__*/_jsx(RecommendedPopularFeatureCard, {
          featureRecord: featureUpgradeConfig,
          apiName: apiName
        }, featureUpgradeConfig.shortName)
      }, featureUpgradeConfig.shortName))
    })]
  });
};
export default RecommendedSalesFeaturesPanel;